// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"SkeletonBlock_skeleton___wVfX","shimmer":"SkeletonBlock_shimmer__jtzny","circle":"SkeletonBlock_circle__2fLNr"};